import React from 'react'

import { AlertBox, Link } from '@vp/swan'

import { useOutOfStockMessage } from './useOutOfStockMessage'

export const OutOfStockToast: React.FC<{
  expectedDate?: Date
}> = ({ expectedDate }) => {
  const { stockMessage, recommendedCategory, isReady } = useOutOfStockMessage(expectedDate)

  return (
    <>
      {isReady && (
        <AlertBox skin="error" style={{ width: '100%' }}>
          {stockMessage}
          {recommendedCategory && (
            <Link href={recommendedCategory.url} paddingLeft={2}>
              {recommendedCategory.name}
            </Link>
          )}
        </AlertBox>
      )}
    </>
  )
}
